import axios from 'axios'
import apiList from './resource.js'
import newApi from "./newApi";

export default {
  // 课程列表获取
  getCourseList: function (data, successfn, errorfn) {
    return axios
      .post(newApi.getAjaxUrl('openapi', 'getCourse'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 获取直播内容
  GetLivingData: function (data, successfn, errorfn) {
    return axios
      .post(newApi.getAjaxUrl('openapi', 'getLivingData'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 推荐课程获取
  getRecommendCourseList: function(data, successfn, errorfn) {
      return axios
          .post(newApi.getAjaxUrl('openapi', 'qryRecommendCourse'), data)
          .then(res => {
              successfn && successfn(res.data)
          })
          .catch(res => {
              errorfn && errorfn(res.data)
          })
  },
  // 课程标签获取
  getCourseTag: function (data, successfn, errorfn){
      return axios
          .post(newApi.getAjaxUrl('openapi', 'getCourseTag'), data)
          .then(res => {
              successfn && successfn(res.data)
          })
          .catch(res => {
              errorfn && errorfn(res.data)
          })
  },
  // 课程详情获取
  courseGetDetail: function (data, successfn, errorfn) {
    return axios
      .get(apiList.course.detail, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 课程目录获取
  courseGetCatalog: function (data, successfn, errorfn) {
    return axios
      .post(newApi.getAjaxUrl('openapi', 'getCourseCatalog'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 用户学习记录查询
  userCourseHistory: function (data, successfn, errorfn){
      return axios
          .post(newApi.getAjaxUrl('openapi', 'getUserClassStudyHistory'), data)
          .then(res => {
              successfn && successfn(res.data)
          })
          .catch(res => {
              errorfn && errorfn(res.data)
          })
  },
  // 用户课程查询
  userCourseGet: function (data, successfn, errorfn) {
    return axios
      .get(apiList.course.userCourse, {
        params: data
      })
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 分级课程列表查询
  getAdvancedCourse: function (data, successfn, errorfn) {
    return axios
      .post(newApi.getAjaxUrl('openapi', 'getCourseLevel'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  },
  // 用户学习历史添加
  postLearningHistory: function (data, successfn, errorfn) {
    return axios
        .post(newApi.getAjaxUrl('openapi', 'addLearningHistory'), data)
      .then(res => {
        successfn && successfn(res.data)
      })
      .catch(res => {
        errorfn && errorfn(res.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/course.js